import React, { Component, createRef, Fragment } from "react";
import PropTypes from "prop-types";
import TooltipInputField from "components/utility/tooltip/TooltipInputField";
import InputFieldTextAreaCounter from "./InputFieldTextAreaCounter";
import ImageChecked from "components/utility/images/ImageChecked";
import MaskedInput from "react-text-mask";

class InputFieldText extends Component {
	constructor(props) {
		super(props);
		this.state = {
			focused: false,
			dirty: false,
			showPassword: false,
			showToggler: false,
			textAreaHeight: "",
			textAreaCounter: 0,
			value: props.value
		};
	}

	inputContainerRef = createRef();

	componentDidUpdate(prevProps) {
		if (this.props.value !== prevProps.value) {
			this.setState({ value: this.props.value });
		}
	}

	componentDidMount() {
		const { dataQA, type, label, name } = this.props;

		// Adds data qa prop to input rendered with MaskedInput from "react-text-mask"
		if (!(dataQA && label && type === "masked")) return;

		const inputContainer = this.inputContainerRef.current;

		if (inputContainer) {
			const maskedInput = inputContainer.querySelector(
				`input[aria-label="${label}"][name="${name}"]`
			);

			if (maskedInput) {
				maskedInput.setAttribute("data-qa", dataQA);
			}
		}
	}

	handleFocus = () => {
		const newState = { ...this.state };
		newState.focused = true;
		if (typeof this.props.handleFocus === "function") {
			this.props.handleFocus();
		}
		if (!this.state.dirty) {
			newState.dirty = true;
		}
		this.setState(newState);
	};

	handleLabelClick = (e) => {
		const label = e.currentTarget;
		label.nextSibling.focus();
	};

	handleBlur = () => {
		this.setState({ focused: false });
	};
	customHandleChange = (e, handleChange) => {
		const input = e.currentTarget;
		const start = input.selectionStart;
		const end = input.selectionEnd;
		if (this.props.forceCase.toLowerCase() === "lower") {
			input.value = input.value.toLowerCase();
		} else if (this.props.forceCase.toLowerCase() === "upper") {
			input.value = input.value.toUpperCase();
		}
		//This is because email-typed input fields don't support setSelectionRange
		if (input["type"] !== "email") {
			input.setSelectionRange(start, end);
		}
		handleChange(e);
	};
	togglePassword = (e) => {
		if (e) {
			e.preventDefault();
		}
		this.setState({ showPassword: !this.state.showPassword });
	};

	onPasswordTogglerKeyDown = (e) => {
		if (e.keyCode === 13) {
			this.togglePassword();
		}
	};

	handlePassword = (e) => {
		const len = e.currentTarget.value.trim().length;
		if (len > 0) {
			if (!this.state.showToggler) {
				this.setState({ showToggler: true });
			}
		} else {
			this.setState({ showToggler: false });
		}
	};
	textAreaHeightResizing = (e) => {
		this.setState({ textAreaHeight: "0" }, () => {
			this.setState({ textAreaHeight: e.target.scrollHeight });
		});
	};
	textAreaCounter = (e) => {
		this.setState({ textAreaCounter: e.target.value.length });
	};
	keyHandler = (e) => {
		const key = e.which || e.keyCode || 0;
		if (key === 13 || key === 32) {
			this.openModal("mask");
		}
	};
	inputSanitization = (e) => {
		let event = e;
		let inputValue = e.target.value;
		let div = document.createElement("div");
		div.innerHTML = inputValue;
		let sanitizedInput = div.textContent || div.innerText || "";
		if (!sanitizedInput) {
			sanitizedInput = inputValue.replace(/[^\w\s!?]/g, "");
		}
		event.target.value = sanitizedInput;
		this.setState({ value: sanitizedInput });
		return event;
	};
	static propTypes = {
		type: PropTypes.string.isRequired,
		label: PropTypes.string,
		dataQA: PropTypes.string,
		name: PropTypes.string,
		value: PropTypes.string,
		error: PropTypes.string,
		hardError: PropTypes.bool,
		touched: PropTypes.bool,
		outerFocused: PropTypes.bool,
		directError: PropTypes.bool,
		className: PropTypes.string,
		charLimit: PropTypes.string,
		isCounter: PropTypes.string,
		handleBlur: PropTypes.func,
		handleChange: PropTypes.func,
		formikHandleBlur: PropTypes.func,
		isRequired: PropTypes.bool,
		mask: PropTypes.array,
		showCheckedImage: PropTypes.bool,
		checkedImageForced: PropTypes.bool,
		tooltipContent: PropTypes.object,
		tooltipPosition: PropTypes.string,
		passwordHideText: PropTypes.string,
		passwordShowText: PropTypes.string,
		onPaste: PropTypes.func,
		handleKeyUp: PropTypes.func,
		autoComplete: PropTypes.string,
		reference: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
		forceCase: PropTypes.string
	};
	static defaultProps = {
		autoComplete: null,
		outerFocused: true,
		checkedImageForced: null,
		forceCase: "none"
	};
	render() {
		const {
			label,
			dataQA,
			type,
			name,
			value,
			error,
			hardError,
			handleChange,
			formikHandleBlur,
			handleKeyUp,
			charLimit,
			isCounter,
			className,
			tooltipContent,
			tooltipPosition,
			showCheckedImage,
			checkedImageForced,
			mask,
			guide,
			passwordHideText,
			passwordShowText,
			outerFocused,
			onPaste,
			autoComplete,
			reference,
			directError
		} = this.props ? this.props : "";
		const { focused, showToggler } = this.state;
		const touched = typeof this.props.touched === "undefined" ? false : this.props.touched;
		let input = null,
			tooltip = null,
			imageChecked = null,
			passwordWidthClass = "";
		let touchedAndBlurred =
			outerFocused === undefined
				? directError
					? true
					: !focused && touched
				: !focused && touched && outerFocused;
		if (tooltipContent) {
			tooltip = (
				<TooltipInputField message={tooltipContent} position={tooltipPosition} opened={focused} />
			);
		}
		if (
			showCheckedImage &&
			((checkedImageForced === null && !error && touched && value.length) ||
				(checkedImageForced !== null && checkedImageForced))
		) {
			imageChecked = (
				<div className="input-field-image-checked">
					<ImageChecked />
				</div>
			);
			passwordWidthClass = "-checked";
		}
		switch (type) {
			case "password-toggler":
				input = (
					<Fragment>
						<input
							autoComplete={autoComplete}
							data-qa={dataQA || "password"}
							data-testid="password"
							type={this.state.showPassword ? "text" : "password"}
							name={name}
							value={value}
							aria-label={label}
							maxLength={charLimit ? charLimit : ""}
							onChange={handleChange}
							onFocus={this.handleFocus}
							onBlur={(e) => {
								this.handleBlur(e);
								formikHandleBlur(e);
							}}
							onKeyUp={(e) => {
								this.handlePassword(e);
								if (handleKeyUp) {
									handleKeyUp(e);
								}
							}}
							onPaste={onPaste}
							ref={reference}
						/>
						{showToggler || (showToggler && error) ? (
							<span
								className={`input-field-password-toggler ${
									imageChecked ? "input-field-password-toggler-with-checked-image" : ""
								}`}
								onKeyDown={this.onPasswordTogglerKeyDown}
								onClick={this.togglePassword}
								onKeyUp={null}
								role="button"
								tabIndex="0"
							>
								{this.state.showPassword ? passwordHideText : passwordShowText}
							</span>
						) : null}
					</Fragment>
				);
				break;
			case "textarea":
				input = (
					<Fragment>
						<textarea
							type={type}
							name={name}
							value={value}
							maxLength={charLimit ? charLimit : ""}
							aria-label={label}
							data-qa={dataQA || "textarea"}
							data-testid="textarea"
							onChange={(e) => {
								this.textAreaHeightResizing(e);
								this.textAreaCounter(e);
								handleChange(e);
							}}
							onKeyUp={handleKeyUp}
							onFocus={this.handleFocus}
							onBlur={(e) => {
								this.handleBlur(e);
								formikHandleBlur(e);
							}}
							style={{ height: this.state.textAreaHeight + "px" }}
							onPaste={onPaste}
							ref={reference}
						/>
					</Fragment>
				);
				break;
			case "masked":
				input = (
					<MaskedInput
						mask={mask}
						guide={guide}
						type="text"
						name={name}
						aria-label={label}
						value={value}
						maxLength={charLimit ? charLimit : ""}
						onKeyUp={handleKeyUp}
						onChange={handleChange}
						onFocus={this.handleFocus}
						onBlur={(e) => {
							this.handleBlur(e);
							formikHandleBlur(e);
						}}
						onPaste={onPaste}
						ref={reference}
					/>
				);
				break;
			default:
				input = (
					<input
						type={type}
						name={name}
						value={value}
						aria-label={label}
						data-qa={dataQA || "default"}
						data-testid="default"
						maxLength={charLimit ? charLimit : ""}
						onKeyUp={handleKeyUp}
						onChange={(e) => this.customHandleChange(e, handleChange)}
						onFocus={this.handleFocus}
						onBlur={(e) => {
							this.handleBlur(this.inputSanitization(e));
							formikHandleBlur(e);
							handleChange(this.inputSanitization(e));
						}}
						onPaste={onPaste}
						ref={reference}
					/>
				);
				break;
		}
		return (
			<div
				className={
					"input-field" +
					(type === "password-toggler" ? " input-field-password " : "") +
					(type === "password-toggler"
						? this.state.showPassword
							? "input-field-password-shown" + passwordWidthClass
							: "input-field-password-hidden" + passwordWidthClass
						: "") +
					(focused && (!error || this.state.dirty)
						? " input-field--active "
						: touchedAndBlurred || (value && value.length)
							? " input-field--dirty "
							: "") +
					(error && touchedAndBlurred ? " input-field--error" : "") +
					" " +
					(className ? className : "")
				}
				style={
					type === "textarea" && this.state.textAreaHeight
						? { height: this.state.textAreaHeight + 20 + "px" }
						: {}
				}
				ref={this.inputContainerRef}
			>
				<span
					className="input-field-label"
					onClick={this.handleLabelClick}
					onKeyUp={this.keyHandler}
					role="presentation"
				>
					{error && touchedAndBlurred ? (hardError ? error : label + " " + error) : label}
				</span>
				{imageChecked}
				{input}
				<div className="input-field-borders">
					<div className="input-field-borders-default" />
					<div className="input-field-borders-action" />
				</div>
				{isCounter === "true" && charLimit ? (
					<InputFieldTextAreaCounter
						textCounter={this.state.textAreaCounter}
						charLimit={charLimit}
					/>
				) : null}
				{tooltip}
			</div>
		);
	}
}

export default InputFieldText;
